import { useTranslation } from "react-i18next";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentNotesCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const notes = ctrl.appointment?.notes;
  if (!notes) return null;
  return (
    <section className="rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <div className="mb-2.5 text-sm font-bold">{t("appointmentDetails.notes")}</div>
      <div className="rounded-xl border border-border/30 bg-background-app px-3.5 py-2.5 text-sm leading-snug text-foreground">
        {notes}
      </div>
    </section>
  );
}
